import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { deserializeFiltersUrl, loadMaterialesSimilaresRequest, removeAllFilters, selectStockItem, setResultsCount, setSelectedFilters } from 'src/app/actions';
import { getLanguage, getLanguageFromUrl, Language } from 'src/app/language';
import { Filter, FilterKey, Maestros, Material, Stock, UnidadMedida } from 'src/app/models';
import { environment } from '../../../environments/environment';

import { maestrosSelector, materialesSimilaresSelector, selectedFiltersSelector, stockSelector } from 'src/app/selectors';
import { FiltersService } from 'src/app/services';
import { ModuleState } from 'src/app/state';

@Component({
  templateUrl: './search-results.container.html',
  styleUrls: ['./search-results.container.css']
})
export class SearchResultsContainer implements OnInit, OnDestroy {

  stock: Stock[] = [];
  maestros: Maestros;
  language: Language;
  query: string = null;
  unidadMedida: UnidadMedida;
  materialesSimilares: Material[] = [];
  subs: Subscription = new Subscription()


  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private filterService: FiltersService,
    private router: Router
    ) {}

  selectStockItem(item: Stock): void {
    return this.store.dispatch(selectStockItem({ item }))
  }

  loadMoreStock() {
    this.store.dispatch(deserializeFiltersUrl({query: this.query, limit: OFF_SET_FACTOR, offset: this.stock.length}))
  }

  goBack(): void {
    this.store.dispatch(removeAllFilters());
  }

  ngOnInit(): void {

    this.store.select(selectedFiltersSelector).subscribe(filters => {
      const filterMaterial: Filter = filters.find(f => f.key === FilterKey.MATERIAL);
      if(filterMaterial) {
        const codigo: Material['CODIGO'] = <string>filterMaterial.value;
        this.store.dispatch(loadMaterialesSimilaresRequest({ param: codigo }));
      } else {
        this.materialesSimilares = [];
      }
    })

    this.store.select(materialesSimilaresSelector).subscribe(materiales => this.materialesSimilares = materiales);

    this.store.select(stockSelector).subscribe(stck => this.stock = [
      ...this.stock,
      ...stck
    ]);
    this.store.select(maestrosSelector).subscribe(maestros => this.maestros = maestros);

    this.store.select((state: ModuleState) => state.unidadMedida).subscribe(unidad => this.unidadMedida = unidad);

    this.route.params.subscribe(params => {
      this.query = params.query;
      if(this.query.length === 0) {
        return this.router.navigateByUrl(getLanguageFromUrl());
      }
      this.stock = [];
      if (environment.pagination)
        this.store.dispatch(deserializeFiltersUrl({query: this.query, limit: OFF_SET_FACTOR, offset: 0}));
      else
        this.store.dispatch(deserializeFiltersUrl({query: this.query, limit: 18446744073709551615, offset: 0}));
    });
    // idioma
    this.language = getLanguage(getLanguageFromUrl());

    if (environment.pagination)
      this.subs.add(this.filterService.onScrolled$.subscribe(() => this.loadMoreStock()));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}

const OFF_SET_FACTOR = 15;
